
import { defineComponent } from 'vue';
import api, { IGetResultItem } from '@/api/admin/backups';
import utils from '@/utils';
import { IHost, IHostBackup } from '@/types/models';

interface IState {
  items: IGetResultItem[];
}

export default defineComponent({
  name: 'Backups',
  data() {
    return {
      items: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        if (!res) return;
        this.items = res.items;
      });
    },

    apiDelete(backupId: number) {
      api.delete(backupId, (res) => {
        if (!res) return;
        utils.success('系统备份删除成功！');
        this.apiGet();
      });
    },

    getUniqueName(host: IHost): string {
      if (!host) return '系统备份';
      return utils.getHostUniqueName(host);
    },

    getUrl(host: IHost): string {
      if (!host) return '#';
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    btnBackupClick() {
      api.submit((res) => {
        if (!res) return;
        utils.success('系统备份成功！');
        this.apiGet();
      });
    },

    btnDeleteClick(backup: IHostBackup) {
      if (backup.isSystem) return;
      utils.alertDelete(
        {
          title: '删除系统备份',
          text: `此操作将删除系统备份 ${backup.backupDate}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(backup.id);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
